import { useTranslation } from "react-i18next";

import GaiaPageGridComponent from "~/modules/app/components/GaiaPageGridComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";

import MasterFormList from "../../components/MasterFormList";

export default function SettingsMasterFormListRoute() {
    const { t } = useTranslation("masterForms");

    return (
        <GaiaPageLayoutColumn>
            <GaiaPageGridComponent title={t("settingsMasterFormListRoute.title")}>
                <MasterFormList />
            </GaiaPageGridComponent>
        </GaiaPageLayoutColumn>
    );
}
